<script>
import eventBus from "../eventBus";
export default {
    props: ['formMenu', 'role'],
    data() {
        return {
            list: {
                data: [],
                meta: {
                    current_page: 1,
                    last_page: 1,
                    total: 0,
                }
            },
            loading: false,
            controllerRecipe: null,
        }
    },
    mounted() {
        this.search();
        eventBus.$on('search-jour', (data) => {
            this.q = data.q;
            this.category_id = data.category_id;
            this.search();
        });
    },
    methods: {
        async search()
        {
            if(this.controllerRecipe) {
                this.controllerRecipe.abort();
            }
            this.controllerRecipe = new AbortController();

            this.loading = true
            try {
                let params = {
                    page: this.list.meta.current_page,
                    q: this.q,
                    user_id: this.formMenu.user_id,
                    category_id: this.category_id,
                }
                let response = await axios.get('/pro/menus/menus/search', {
                    params,
                    signal: this.controllerRecipe.signal
                });
                this.list = response.data
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        nextPage() {
            if (this.list.meta.current_page < this.list.meta.last_page) {
                this.list.meta.current_page++;
                this.search();
            }
        },
        prevPage() {
            if (this.list.meta.current_page > 1) {
                this.list.meta.current_page--;
                this.search();
            }
        },
    }
}
</script>

<template>
    <div>
        <div class="card position-relative">
            <div v-if="loading" class="loading-overlay d-flex align-items-center justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Chargement...</span>
                </div>
            </div>

            <div class="card-header">
                <h3 class="card-title">Menus - {{ list.meta.total }} </h3>
            </div>

            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                <thead>
                <tr>
                    <th></th>
                    <th class="text-center w-1"><i class="icon-people"></i></th>
                    <th>Nom</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in list.data" :key="item.id">
                    <td>
                        <input type="checkbox" v-model="formMenu.items" :value="item"  >
                    </td>
                    <td class="text-center">
                        {{ item.id }}
                    </td>
                    <td>
                        <a target="_blank" :href="item.url">{{ item.name }}</a><br>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <template v-if="list.meta.last_page > 1">
            <ul role="navigation" class="pagination">
                <li @click.prevent="prevPage" aria-disabled="true" aria-label="« Précédent" class="page-item" :class="{'disabled': list.meta.current_page == 1}" ><a href="#" aria-hidden="true" class="page-link">‹</a></li>
                <li  class="page-item">
                    <span aria-hidden="true" class="page-link">{{ list.meta.current_page }} / {{ list.meta.last_page }}</span>
                </li>
                <li @click.prevent="nextPage" class="page-item" :class="{'disabled': list.meta.current_page == list.meta.last_page}"><a href="#" rel="next" aria-label="Suivant »" class="page-link">›</a></li>
            </ul>
        </template>
    </div>
</template>

<style scoped>
.position-relative {
    position: relative;
}
/* Overlay full covering */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7); /* Fond semi-transparent */
    z-index: 10;
}
.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>
